export default __webpack_public_path__ + "static/media/bgAsset3.fec312af.svg";